import React, { useEffect, useState } from "react";
import AddSupplier from "../addSpplier/AddSupplier";
import baseUrl from "../../../../api/baseUrl";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SearchIcon from "@mui/icons-material/Search";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import BusinessIcon from "@mui/icons-material/Business";

function AllSupplier() {
  const [open, setopen] = useState(false);
  const [id, setid] = useState("");
  const [data, setdata] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    baseUrl
      .get("client/inventory/supplier/findAllSupplier")
      .then((response) => setdata(response.data.data))
      .catch((error) => console.error(error?.response));
  }, [open]);

  const closeModal = () => {
    setopen(false);
    setid("");
  };

  const openModal = () => setopen(true);

  const update = (id: any) => {
    setid(id);
    setopen(true);
  };

  const filteredData = data.filter((item: any) =>
    item?.supplierName?.toLowerCase().includes(search.toLowerCase()) ||
    item?.suppliercompany?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      {/* Header Card */}
      <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 p-3 mb-3">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2.5">
          <div className="relative flex-1 max-w-md">
            <SearchIcon
              className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
              sx={{ fontSize: 16 }}
            />
            <input
              type="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search suppliers..."
              className="w-full pl-10 pr-3 py-2 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-xs text-slate-800 dark:text-slate-200 placeholder:text-slate-400 dark:placeholder:text-slate-500"
            />
          </div>
          <div className="flex items-center gap-2.5">
            <div className="flex items-center gap-1.5 px-3 py-1.5 bg-amber-50 dark:bg-amber-900/40 rounded-lg">
              <LocalShippingIcon className="text-amber-500 dark:text-amber-300" sx={{ fontSize: 16 }} />
              <span className="font-bold text-xs text-amber-600 dark:text-amber-300">{data.length}</span>
              <span className="text-slate-500 dark:text-slate-400 text-[10px]">Suppliers</span>
            </div>
            <button
              onClick={() => openModal()}
              className="flex items-center gap-1.5 px-4 py-2.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg hover:shadow-lg hover:shadow-primary/20 transition-all font-medium text-xs"
            >
              <AddIcon sx={{ fontSize: 16 }} />
              Add Supplier
            </button>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 overflow-hidden">
        {/* Mobile Cards */}
        <div className="md:hidden p-3 space-y-2">
          {filteredData.length === 0 ? (
            <div className="text-center py-8 text-slate-400 dark:text-slate-500">
              <LocalShippingIcon sx={{ fontSize: 36 }} className="mb-2" />
              <p className="text-xs">No suppliers found</p>
            </div>
          ) : (
            filteredData.map((item: any, i: number) => (
              <div key={i} className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-3 border border-slate-100 dark:border-slate-600">
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2.5">
                    <div className="w-8 h-8 bg-gradient-to-br from-primary to-primaryLight rounded-full flex items-center justify-center text-white font-semibold text-xs">
                      {item?.supplierName?.charAt(0)?.toUpperCase()}
                    </div>
                    <div>
                    <p className="font-semibold text-xs text-slate-800 dark:text-slate-100">{item?.supplierName}</p>
                    <p className="text-[10px] text-slate-500 dark:text-slate-400">{item?.suppliercompany}</p>
                    </div>
                  </div>
                </div>
                <div className="space-y-1.5 text-xs mb-2">
                  <div className="flex items-center gap-1.5 text-slate-600 dark:text-slate-300">
                    <EmailIcon sx={{ fontSize: 14 }} className="text-slate-400" />
                    <span>{item?.email}</span>
                  </div>
                  <div className="flex items-center gap-1.5 text-slate-600 dark:text-slate-300">
                    <PhoneIcon sx={{ fontSize: 14 }} className="text-slate-400" />
                    <span>{item?.phoneNumber}</span>
                  </div>
                </div>
                <button
                  onClick={() => update(item._id)}
                  className="w-full flex items-center justify-center gap-1 px-3 py-2 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg hover:shadow-lg hover:shadow-primary/20 transition-all text-xs font-medium"
                >
                  <EditIcon sx={{ fontSize: 14 }} />
                  Edit
                </button>
              </div>
            ))
          )}
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-slate-200 dark:border-slate-600">
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">No</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Name</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Company</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Email</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Contact</th>
                <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-600">
              {filteredData.length === 0 ? (
                <tr>
                  <td colSpan={6} className="px-3 py-8 text-center text-slate-400 dark:text-slate-500">
                    <LocalShippingIcon sx={{ fontSize: 36 }} className="mb-2" />
                    <p className="text-xs">No suppliers found</p>
                  </td>
                </tr>
              ) : (
                filteredData.map((item: any, i: number) => (
                  <tr key={i} className="hover:bg-slate-50/50 dark:hover:bg-slate-700/50 transition-colors">
                    <td className="px-3 py-2">
                      <span className="px-2 py-0.5 text-[10px] font-semibold rounded-md bg-slate-100 dark:bg-slate-600 text-slate-600 dark:text-slate-300">
                        {i + 1}
                      </span>
                    </td>
                    <td className="px-3 py-2">
                      <div className="flex items-center gap-2.5">
                        <div className="w-7 h-7 bg-gradient-to-br from-primary to-primaryLight rounded-full flex items-center justify-center text-white text-[10px] font-semibold">
                          {item?.supplierName?.charAt(0)?.toUpperCase()}
                        </div>
                        <span className="font-medium text-xs text-slate-800 dark:text-slate-100">{item?.supplierName}</span>
                      </div>
                    </td>
                    <td className="px-3 py-2">
                      <div className="flex items-center gap-1.5">
                        <BusinessIcon sx={{ fontSize: 14 }} className="text-slate-400" />
                        <span className="text-xs text-slate-600 dark:text-slate-300">{item?.suppliercompany}</span>
                      </div>
                    </td>
                    <td className="px-3 py-2">
                      <div className="flex items-center gap-1.5">
                        <EmailIcon sx={{ fontSize: 14 }} className="text-slate-400" />
                        <span className="text-xs text-slate-600 dark:text-slate-300">{item?.email}</span>
                      </div>
                    </td>
                    <td className="px-3 py-2">
                      <div className="flex items-center gap-1.5">
                        <PhoneIcon sx={{ fontSize: 14 }} className="text-slate-400" />
                        <span className="text-xs text-slate-600 dark:text-slate-300">{item?.phoneNumber}</span>
                      </div>
                    </td>
                    <td className="px-3 py-2">
                      <button
                        onClick={() => update(item._id)}
                        className="p-1.5 rounded-md bg-amber-50 dark:bg-amber-900/40 text-amber-600 dark:text-amber-300 hover:bg-amber-100 dark:hover:bg-amber-900/60 transition-colors"
                        title="Edit"
                      >
                        <EditIcon sx={{ fontSize: 16 }} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {open && <AddSupplier id={id} closeModal={closeModal} />}
    </>
  );
}

export default AllSupplier;
